import React from "react";

import PinChromeExtensionImage from "@common/assets/images/chrome-extension/pin-shake-chrome-extension.png";
import PinChromeExtensionArrow from "@common/assets/images/chrome-extension/pin-shake-extension-arrow.svg";
import PinChromeExtensionPuzzle from "@common/assets/images/chrome-extension/pin-shake-extension-puzzle.svg";

import * as Styled from "./ChromeExtensionWelcomeView.styles";

export default function ChromeExtensionWelcomeView() {
  return (
    <Styled.PinExtensionRoot>
      <Styled.PinExtensionNote>
        <Styled.PinExtensionStepText
          p2
          style={{ marginRight: 5 }}
        >
          {"1.  Click the puzzle to see Shake"}
        </Styled.PinExtensionStepText>
        <Styled.PinExtensionPuzzleIcon
          style={{ marginRight: 3 }}
          src={PinChromeExtensionPuzzle}
        />
        <Styled.PinExtensionPuzzleIcon
          style={{ marginBottom: 7 }}
          src={PinChromeExtensionArrow}
        />
      </Styled.PinExtensionNote>

      <Styled.PinExtensionContent>
        <Styled.PinExtensionStepText
          style={{ marginBottom: 20 }}
          p2
        >
          {"2.  Pin it there:"}
        </Styled.PinExtensionStepText>
        <Styled.PinExtensionImage src={PinChromeExtensionImage} />
        <Styled.PinExtensionStepText
          style={{ marginBottom: 20 }}
          p2
        >
          {"3.  Close this tab:"}
        </Styled.PinExtensionStepText>
        <Styled.PinExtensionFooterText p2>
          {"Once you’ve pinned Shake, you can close this tab."}
        </Styled.PinExtensionFooterText>
      </Styled.PinExtensionContent>
    </Styled.PinExtensionRoot>
  );
}
